var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { axios } from "../Support/axios";
import { HttpFormError } from "../Support/HttpFormError";
var SanctumAuthentication = (function (_super) {
    __extends(SanctumAuthentication, _super);
    function SanctumAuthentication() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.passwordFieldType = 'password';
        _this.data = {
            email: null,
            password: null,
            remember: false,
        };
        _this.mfa = false;
        _this.mfa_recovery = false;
        return _this;
    }
    SanctumAuthentication.prototype.signIn = function () {
        var _this = this;
        return this.generateCsrfCookie().then(function () { return _this.sendLoginRequest(_this.data); }).catch(function (e) { return _this.setError(e); });
    };
    SanctumAuthentication.prototype.generateCsrfCookie = function () {
        return axios.get('/sanctum/csrf-cookie');
    };
    SanctumAuthentication.prototype.sendMfaCheck = function () {
        var _this = this;
        var url = '/submit-two-factor';
        return axios.post(url, this.data).catch(function (e) { return _this.setError(e); });
    };
    SanctumAuthentication.prototype.mfaRecovery = function () {
        this.mfa_recovery = true;
    };
    SanctumAuthentication.prototype.sendLoginRequest = function (data) {
        var _this = this;
        return axios.post('/login', data)
            .then(function (response) {
            if (response.data.mfa) {
                _this.mfa = true;
            }
        });
    };
    SanctumAuthentication.prototype.togglePasswordFieldType = function () {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        return this.passwordFieldType;
    };
    return SanctumAuthentication;
}(HttpFormError));
export { SanctumAuthentication };
